import { inject } from 'inversify';
import { HttpClientType, HttpStatusCode } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';

import { bind } from '@infra/container';
import { ImportDeclarationDto } from '../dto';

export type IImportDeclarationsExcelRepoResponse = IRepoResponse<HttpStatusCode.OK> | IRepoResponse<HttpStatusCode.BAD_REQUEST | HttpStatusCode.INTERNAL_SERVER_ERROR, string>;

export type IImportDeclarationsExcelRepo = IRepo<[ImportDeclarationDto], IImportDeclarationsExcelRepoResponse>;

export const ImportDeclarationsExcelRepoType = Symbol.for('ImportDeclarationsExcelRepo');

@bind(ImportDeclarationsExcelRepoType)
export class ImportDeclarationsExcelRepo implements IImportDeclarationsExcelRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: ImportDeclarationDto) {
    try {
      const url = urlMaker('/api/admin/export/declaration/import');
      const body = new FormData();

      appendToFormData(dto, body);

      const result = await this.httpClient.post({ url, body });

      if (result.status === HttpStatusCode.OK) {
        return {
          status: HttpStatusCode.OK as HttpStatusCode.OK,
          response: result.data.message || 'Məlumatlar uğurla yükləndi',
        };
      } else if (result.status === HttpStatusCode.BAD_REQUEST || result.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {
        return {
          status: HttpStatusCode.BAD_REQUEST as HttpStatusCode.BAD_REQUEST,
          response: Object.values(result.data.errors).flat().join('. ') || 'Məlumatlar əldə edilə bilmədi',
        };
      } else {
        return {
          status: HttpStatusCode.BAD_REQUEST as HttpStatusCode.BAD_REQUEST,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: HttpStatusCode.INTERNAL_SERVER_ERROR as HttpStatusCode.INTERNAL_SERVER_ERROR,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
